import React from 'react';
import "../../styles/chats/delete_message.css";

const DeleteMessage = ({onDelete, isDeleteMessageDialogShow, setDeleteMessageDialogShow}) => {
    return(
        <div className={`delete_message_dialog ${isDeleteMessageDialogShow ? "show" : ""}`}>
            <div className="delete_message_dialog_overlay"></div>
            <div className="delete_message_dialog_content">
                <p className="delete_message_dialog_content_header">Confirm Deletion</p>
                <p className="delete_message_dialog_content_text">Are you sure you want to delete this messsage?</p>
                <div className="delete_message_dialog_buttons_container">
                    <div className="delete_message_dialog_cancel_button" onClick={() => setDeleteMessageDialogShow(false)}>Cancel</div>
                    <div className="delete_message_dialog_button" onClick={onDelete}>Delete</div>
                </div>
            </div>
        </div>
    );
};

export default DeleteMessage;